

export default {
    components: {
    },
    created() {

        let t = this;


    },
    activated() {

        let t = this;

    },
    methods: {


    },
    data() {
        return {
        };
    },
    computed: {
    }
};
